<template>
<div>
  <h4>Surgical Site Infection Surveillance<template v-if="status"> - ({{ status | titlecase }} Documents)</template></h4>
    <div class="form-group row">
      <div class="col-lg-4">
        <input type="text"
        class="form-control"
        placeholder="Search PRN or Name"
        v-model="search_term">
      </div>
    </div>
    <grid-table
      :table-data='device_monitoring'
      :options='device_monitoring_grid.options'
      :columns="device_monitoring_grid.columns">
      <router-link
        slot='id'
        slot-scope='props'
        :to="{name: 'SurgeryMonitoringFormDetail', params:  {patientId: props.row.patient.id, documentId: props.row.id, hospital: props.row.hospital }}">
        {{ props.row.id }}
      </router-link>
      <template slot="select" slot-scope="props">
        <input type="checkbox" id="checkbox" v-model="props.row.selected">
      </template>
      <template slot="surgery_date" slot-scope="props">
        {{ props.row.content.start | datetime }}
      </template>
      <template slot="surgery" slot-scope="props">
        {{ props.row.content.surgery }}
      </template>
      <template
        slot='patient'
        slot-scope='props'>
        <router-link
          :to="{name: 'PatientDetail', params:  {hospitalId: props.row.patient.hospital_id, hospital: props.row.hospital }}">{{ props.row.patient.name }}</router-link> #{{ props.row.patient.hospital_id }}
      </template>
      <template
        slot='actions'
        slot-scope='props'>
        <i class='fa fa-trash-o' @click='delete_doc(props.row.id)'></i>
      </template>
      <template slot='no_results'>
        No Sheets Found
      </template>
    </grid-table>
    <grid-pagination
      :page="page"
      :route-link="{ name: $route.name, query: $route.query }"
      :count="result_count">
    </grid-pagination>

    <div class="p-3">
      <button class='btn btn-outline-primary' v-bind:disabled="!selectedItems.length" @click="changeStatus()">Move to {{ status == 'added' ? 'Pending' : 'Added' }}</button>
      <button v-if="status !== 'deleted'" class='btn btn-outline-primary' v-bind:disabled="!selectedItems.length" @click="changeStatus('deleted')">Move to Trash</button>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import axiosConfig from '@/common/axiosConfig'
import { mapGetters } from 'vuex'
import GridTable from '@/components/shared/datatable/Grid'
import GridPagination from '@/components/shared/datatable/GridPagination'
import CreateRouterMixin from '@/common/routerMixin'
import _ from 'lodash'

var getData = function (route) {
  return axios.get(`ic_documents/hospital/${route.params.hospital}/surgical_site_monitoring/`,
    Object.assign({ params: route.query }, axiosConfig)
  )
}

var routerMixin = CreateRouterMixin(getData)

export default {
  name: 'SurveillancePatientDetail',
  props: {
    page: {
      type: Number,
      default: 1
    }
  },
  mixins: [routerMixin],
  data: () => {
    return {
      device_monitoring: [],
      result_count: 0,
      device_monitoring_grid: {
        columns: ['select', 'id', 'surgery_date', 'patient', 'surgery', 'modified', 'actions'],
        options: {
          dateColumns: ['surgery_date', 'modified'],
          headings: {
            id: '#',
            surgery_date: 'Surgery Date'
          }
        }
      },
      search_term: ''
    }
  },
  computed: {
    ...mapGetters(['currentHospital']),
    selectedItems () {
      return _.compact(_.map(this.device_monitoring, item => {
        return item.selected ? item.id : null
      }))
    },
    status () { return this.$route.query.status }
  },
  watch: {
    search_term: function (newSearch, oldSearch) {
      var route = { name: this.$route.name, query: {} }

      // A number usually means hospital ID
      if (newSearch.match(/\d{4,10}/)) { route.query.patient__hospital_id = newSearch }

      // search syntax
      if (newSearch.match(/[A-Za-z]+/)) {
        route.query.search = newSearch
      }

      this.$router.push(route)
    }
  },
  methods: {
    setData (data) {
      this.device_monitoring = _.map(data.results, result => {
        result.selected = false
        return result
      })
      this.result_count = data.count
    },
    async delete_doc (id) {
      const msg = 'Deleting document...'
      if (confirm(msg)) {
        await axios.delete(`ic_documents/hospital/${this.$route.params.hospital}/surgical_site_monitoring/${id}/`, axiosConfig)
        this.$store.dispatch('display_notification', {
          message: 'Successfully Deleted'
        })
        const response = await getData(this.$router.currentRoute)
        this.setData(response.data)
      }
    },
    async changeStatus (statusParam) {
      let newStatus = this.status === 'pending' ? 'added' : 'pending'
      if (statusParam) {
        newStatus = statusParam
      }
      await axios.post(`ic_documents/hospital/${this.$route.params.hospital}/surgical_site_monitoring/change_status/`,
        { items: this.selectedItems, status: newStatus },
        axiosConfig)

      this.$store.dispatch('display_notification', {
        message: `Moved to ${newStatus} list`
      })
      const response = await getData(this.$router.currentRoute)
      this.setData(response.data)
    }
  },
  components: {
    'grid-table': GridTable,
    'grid-pagination': GridPagination
  }
}
</script>
